<div class="zentra-admin-success-dialog">
  <h1 mat-dialog-title>Success!</h1>
  <div mat-dialog-content class="message">
    <h3>
      Subscription successfully configured.
      <br />
      An invite will be sent to the Purchaser to login and complete Subscription
      Details and payment.
    </h3>
  </div>
  <div mat-dialog-actions class="actions">
    <button
      color="primary"
      routerLink="/zentra-subscriptions"
      mat-raised-button
      mat-dialog-close
    >
      Home
    </button>
  </div>
</div>
